import { useLingui } from '@lingui/react/macro';
import { MATCH_SWITCH_LOADER_LABEL } from 'modules/overlay-v2/domain/constants/readiness';
import ImGameWordmark from 'modules/overlay-v2/ui/components/imgame-wordmark';
import React from 'react';

import { LoaderRoot } from './styles';

interface MatchSwitchLoaderProps {
  /** Подготовка сошлась — знак доигрывает уход, табло уже смонтировано под ним. */
  isClosing: boolean;
}

/**
 * Экран переключения матча: только переливающийся знак ImGame сверху по центру.
 *
 * Чеклист между матчами видят зрители — оверлей висит в OBS, — поэтому при переключении
 * показываем нейтральный знак. Он одинаков для любого турнира и шаблона, так что оформление
 * чужого турнира на экран не попадёт. При ошибке знак сменит чеклист.
 */
function MatchSwitchLoader({ isClosing }: MatchSwitchLoaderProps) {
  const { t } = useLingui();

  return (
    <LoaderRoot isClosing={isClosing} role={'status'} aria-label={t(MATCH_SWITCH_LOADER_LABEL)} data-closing={isClosing}>
      <ImGameWordmark />
    </LoaderRoot>
  );
}

export default React.memo(MatchSwitchLoader);
